/* ==========================================================================
   Funkissd — Cart drawer discount code
   Shopify's AJAX Cart API has no endpoint to apply a discount code to an
   in-progress cart, so the standard no-backend approach is used here:
   submitting redirects the browser to Shopify's built-in
   /discount/{code}?redirect={current page} URL, which applies the code to
   the session and redirects straight back. That means applying a code
   does a full page reload (the drawer will re-open closed, since it's a
   fresh page load) rather than updating instantly like the rest of the
   drawer — a known trade-off of doing this without a backend/app.
   ========================================================================== */
(function () {
  function init() {
    var form = document.getElementById('funkissd-cart-discount-form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = document.getElementById('funkissd-cart-discount-input');
      var code = input && input.value.trim();
      if (!code) return;

      var redirectTo = window.location.pathname + window.location.search;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTo);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
